import { axiosInstance, axiosRequestWithAuth } from './../constants/server.constant';
export const FlavorService = {
    getAllRegionFlavors,
    getAllRegionFlavorsDb,
    getDiscounts,
    getPromoCodeDetails,
    getServerExists,
    getAllBmFlavors,
    getBmDiscounts,
    getMonthlyDiscounts
};

function getUserId() {
    return localStorage.getItem('userId');
}

async function getAllBmFlavors() {
    let plans = [];
    return await axiosInstance.get("/baremetal/getallbm/" + getUserId(), axiosRequestWithAuth).then
        (resp => {

            let data = resp.data;

            if(data === undefined || data === null) {
                return plans;
            }
            data.forEach(elem => {
                let newElem = {
                    id: elem.flavour_id,
                    monthlyRate: elem.monthly_price,
                    type: elem.type
                };
                let nameArr = elem.name.split(' ');


                let regandtype = nameArr[0].toString().split('/');
                newElem.planName = nameArr[1];
                newElem.region = regandtype[0];
                newElem.parenttype = regandtype[1];
                if(nameArr[1] !== undefined) {
                    let details = nameArr[1].toString().split('/');
                    newElem.ram = elem.ram / 1024 + ' GB';
                    let cpu = ' CPU';
                    if(elem.vcpus > 1) {
                        cpu = ' CPUs';
                    }
                    newElem.cpus = elem.vcpus + cpu;
                    newElem.storage = elem.disk + ' GB';
                    newElem.hourlyRate = parseFloat(newElem.monthlyRate / (28 * 24)).toFixed(4);
                    newElem.bandwidth = elem.bandwidth;
                } else {
                    newElem.ram = '';
                    newElem.cpus = '';
                    newElem.storage = '';
                }
                newElem.processor = elem.processor;
                newElem.diskType = elem.disk_type;
                newElem.ethernet = elem.ethernet;
                newElem.threads = elem.threads;
                newElem.type = elem.type;
                newElem.available = elem.available;
                newElem.units = elem.units;
                newElem.resourceClass = elem.resourceClass;
                plans.push(newElem);
            });
            return plans;
        })
        .catch(error => {
            return [];
        });
}
async function getAllRegionFlavors() {

    return await axiosInstance.get('/flavors/' + getUserId() + '/all', axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            let newData = [];
            for(var item of Object.keys(data)) {
                let flavorList = data[item];
                if(flavorList === undefined || flavorList === null) {
                    continue;
                }
                newData = newData.concat(flavorList);
            }
            return newData;
        }).catch(function (error) {
            return [];
        });
}

async function getAllRegionFlavorsDb() {

    return await axiosInstance.get('/flavors/' + getUserId() + '/all/db', axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            let newData = [];
            for(var item of Object.keys(data)) {
                let flavorList = data[item];
                if(flavorList === undefined || flavorList === null) {
                    continue;
                }
                newData = newData.concat(flavorList);
            }
            return newData;
        }).catch(function (error) {
            return [];
        });
}

async function getDiscounts() {

    return await axiosInstance.get('/flavors/getpromocodebystatus/' + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            return data;
        }).catch(function (error) {
            return [];
        });
}

async function getMonthlyDiscounts(type) {

    return await axiosInstance.get('/flavors/getpromocodebystatus/' + getUserId() + "?discountType=" + type, axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            return data;
        }).catch(function (error) {
            return [];
        });
}

async function getBmDiscounts() {

    return await axiosInstance.get('/flavors/getpromocodebystatus/' + getUserId() + "?type=baremetal", axiosRequestWithAuth)
        .then(resp => {
            let data = resp.data;
            return data;
        }).catch(function (error) {
            return [];
        });
}

async function getPromoCodeDetails() {

    return await axiosInstance.get('/flavors/getpromocodebystatus/' + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp;
        }).catch(function (error) {
            return [];
        });
}

async function getServerExists(serverId) {

    return await axiosInstance.get('/resize/checkserverid/' + serverId + '/' + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            return resp.data;
        }).catch(function (error) {
            return false;
        });
}

export default FlavorService;